import React from 'react'
import { connect } from 'react-redux'

import { Modal } from '@material-ui/core'
import { ActionCreator } from 'redux'
import { ModalCard } from '../../components'
import { editDeviceEnd } from '../../state/SystemCache/actions'
import { getEditDevice } from '../../state/SystemCache/selectors'
import { State } from '../../types'
import DeviceForm from '.'

type Props = {
  editDevice: { editing: boolean; deviceId: string }
  handleModalClose: ActionCreator<void>
}

function DeviceFormModal(props: Props) {
  return (
    <Modal open={props.editDevice.editing} onClose={props.handleModalClose}>
      <ModalCard>
        <DeviceForm deviceId={props.editDevice.deviceId} />
      </ModalCard>
    </Modal>
  )
}

const conn = connect(
  (state: State) => ({
    editDevice: getEditDevice(state),
  }),
  {
    handleModalClose: editDeviceEnd,
  },
)

const DeviceFormModalContainer = conn(DeviceFormModal)

export default DeviceFormModalContainer
